import store from "../redux/store";

import Cookies from "js-cookie";

import { actionRefreshToken } from "../redux/loginReduser/actionRefreshToken";

import { setLoginStatus } from "../redux/loginReduser/actionLogin";

let refreshingToken = false;
let refreshPromise = null;

export async function fetchWithToken(url, options = {}) {
  let accessToken = Cookies.get("accessToken");
  const refreshToken = Cookies.get("refreshToken");

  const headers = {
    ...options.headers,
    Authorization: `Bearer ${accessToken}`,
  };

  const modifiedOptions = {
    ...options,
    headers,
  };

  return fetch(url, modifiedOptions)
    .then(async (response) => {
      if (response.status === 401 && refreshToken) {
        console.log("🔄 401 ошибка. Обновляем токен...");

        if (!refreshingToken) {
          refreshingToken = true;
          refreshPromise = store
            .dispatch(actionRefreshToken())
            .then(() => {
              refreshingToken = false;
              refreshPromise = null;
              return Cookies.get("accessToken");
            })
            .catch(() => {
              refreshingToken = false;
              refreshPromise = null;
              store.dispatch(setLoginStatus(false));
              console.error("❌ Ошибка обновления токена!");
              return null;
            });
        }

        const newAccessToken = await refreshPromise;

        if (!newAccessToken) {
          return null;
        }

        console.log("🔁 Повторный запрос...");
        modifiedOptions.headers.Authorization = `Bearer ${newAccessToken}`;

        return fetch(url, modifiedOptions);
      }

      if (response.status === 401 && !refreshToken) {
        store.dispatch(setLoginStatus(false));
        console.error("❌ Токен устарел!");
      }

      return response;
    })
    .catch((error) => {
      console.error("❌ Ошибка запроса:", error);
      return null;
    });
}
